export default "#### We can’t deliver to this address.\n\nConsider an alternate address if you have one, or choose collection instead.\n";